class PageDwellListener {
  private dwellStart = 0;
  private finished = false;

  private onDwellEnd(cb: (dwellTime: number) => void): void {
    if (!this.finished) {
      this.finished = true;
      const dwellTime = Date.now() - this.dwellStart;
      cb(dwellTime);
    }
  }

  public listen(cb: (dwellTime: number) => void): void {
    this.dwellStart = Date.now();
    this.finished = false;

    window.addEventListener('beforeunload', () => {
      this.onDwellEnd(cb);
    });
    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          this.onDwellEnd(cb);
        }
      },
      false
    );
  }
}

export const pageDwellListener = new PageDwellListener();
